import _extends from "@babel/runtime/helpers/esm/extends";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["sx", "renderLabel", "isActive", "label", "value"];

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

import React, { forwardRef, useContext } from 'react';
import Flex from '../Flex';
import { useAbstractButton } from '../AbstractButton';
import { TabListContext } from './contexts';
var styles = {
  root: {
    alignItems: 'stretch',
    variant: 'Tab',
    flexShrink: 0,
    flexGrow: 1,
    flexBasis: 'auto',
    flexDirection: 'column',
    minWidth: '0px',
    minHeight: '0px',
    position: 'relative',
    zIndex: 0,
    borderBottom: function borderBottom(theme) {
      return theme.separatorBorder.bold;
    }
  },
  label: {
    variant: 'TabLabel',
    cursor: 'pointer',
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
    flexShrink: 0,
    flexBasis: 'auto',
    justifyContent: 'center',
    outlineStyle: 'none',
    alignItems: 'center',
    minWidth: '0px',
    minHeight: '0px',
    position: 'relative',
    color: 'inherit',
    zIndex: 0
  }
};
var Tab = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var sx = _ref.sx,
      _ref$renderLabel = _ref.renderLabel,
      Label = _ref$renderLabel === void 0 ? Flex : _ref$renderLabel,
      isActive = _ref.isActive,
      label = _ref.label,
      value = _ref.value,
      rest = _objectWithoutProperties(_ref, _excluded);

  var _useContext = useContext(TabListContext),
      dispatch = _useContext.dispatch,
      currentValue = _useContext.state;

  var buttonProps = useAbstractButton({
    onClick: function onClick() {
      return dispatch({
        type: 'change',
        payload: value
      });
    }
  });
  return /*#__PURE__*/React.createElement(Flex, _extends({
    sx: _objectSpread(_objectSpread(_objectSpread({}, sx), styles.root), {}, {
      borderBottomColor: function borderBottomColor(theme) {
        return isActive || currentValue === value ? theme.colors.secondary : 'transparent';
      }
    })
  }, rest, buttonProps, {
    ref: ref
  }), /*#__PURE__*/React.createElement(Label, _extends({
    sx: styles.label
  }, rest), label));
});
process.env.NODE_ENV !== "production" ? void 0 : void 0;
Tab.displayName = 'Tab';
export default Tab;